<template>
  <b-form @submit.prevent="onSubmit">
    <b-row>
      <b-col sm>
        <b-form-group label="Recherche" label-for="search">
          <b-form-input
            id="libelle"
            v-model="search.search"
            name="search"
            type="text"
          />
        </b-form-group>
      </b-col>

      <b-col sm>
        <b-form-group label="Catégorie" label-for="categorieSaisie">
          <select
            id="categorieSaisie"
            v-model="search.categorieId"
            class="form-control"
            name="categorieSaisie"
          >
            <option :value="null"></option>
            <option
              v-for="c in categories"
              :key="c.id"
              :class="
                isCategorieRecette(c.typeSaisie)
                  ? 'text-success'
                  : 'text-danger'
              "
              :value="c.id"
            >
              {{ c.libelle }}
            </option>
          </select>
        </b-form-group>
      </b-col>
      <b-col sm>
        <div>
          <label class="typo__label">Adhérent</label>
          <multiselect
            v-model="selectedAdherent"
            :clear-on-select="true"
            :close-on-select="true"
            :hide-selected="false"
            :multiple="false"
            :options="simpleAdherents"
            :preselect-first="false"
            :preserve-search="true"
            deselectLabel="Clique pour supprimer"
            label="libelle"
            name="adherent"
            placeholder="Sélection"
            selectLabel
            selectedLabel="Selection"
            track-by="id"
          >
            <span slot="noResult">Aucun élément trouvé</span>
          </multiselect>
        </div>
      </b-col>

      <b-col sm>
        <b-form-group class="mr-2" label="Devise" label-for="devise">
          <select v-model="search.deviseId" class="form-control" name="devise">
            <option :value="null"></option>
            <option v-for="d in devises" :key="d.id" :value="d.id">
              {{ d.libelle }}
            </option>
          </select>
        </b-form-group>
      </b-col>
      <b-col sm>
        <b-form-group label="Mode de paiement" label-for="modePaiement">
          <select
            v-model="search.modePaiementId"
            class="form-control"
            name="devise"
          >
            <option :value="null"></option>
            <option v-for="mp in modePaiements" :key="mp.id" :value="mp.id">
              {{ mp.libelle }}
            </option>
          </select>
        </b-form-group>
      </b-col>
      <b-col sm>
        <b-form-group label="Projet" label-for="projetSaisie">
          <select
            v-model="search.projetId"
            class="form-control"
            name="projetSaisie"
          >
            <option :value="null"></option>
            <option v-for="p in projets" :key="p.id" :value="p.id">
              {{ p.libelle }}
            </option>
          </select>
        </b-form-group>
      </b-col>
      <b-col sm>
        <b-form-group label="Année" label-for="annee">
          <select v-model="search.year" class="form-control" name="annee">
            <option :value="null"></option>
            <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
          </select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row align-h="end">
      <b-col>
        <b-button
          class="m-1 float-right"
          variant="primary"
          @click="exportSaisie()"
          >Export
        </b-button>
        <b-button class="m-1 float-right" type="submit" variant="primary"
          >Filtrer
        </b-button>
        <b-button class="m-1 float-right" variant="danger" @click="resetForm()"
          >Reset
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>
<script>
import { Multiselect } from "vue-multiselect";
import ApiService from "../../service/apiService";
import TypeLibelleService, {
  isCategorieRecette,
} from "../../service/typeLibelleService";

export default {
  name: "saisieSearch",
  components: {
    Multiselect,
  },
  data() {
    return {
      search: {},
      //Object qui contient les libelle qui servent à comparer ("RECETTE", "DEPENSE", "DON"...)
      TypeLibelleService: TypeLibelleService,
      //Tableau d'objets pour le formulaire:
      categories: [],
      projets: [],
      modePaiements: [],
      simpleAdherents: [],
      devises: [],
      years: [],
      //Adhérent selectionné dans le multiselect
      selectedAdherent: {},
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    isCategorieRecette,
    onSubmit() {
      this.setAdherentId();
      this.$emit("searchUpdate", this.search);
    },
    resetForm() {
      this.search = {};
      this.selectedAdherent = {};
    },
    /**
     * Export les saisies en CSV
     * Le CSV est récupérer du serveur et envoyé en téléchargement au client
     */
    async exportSaisie() {
      var res = await ApiService.saisie.exportCSV(this.search);
      this.res = res;
      if (res) {
        // var fileURL = window.URL.createObjectURL(new Blob([res.data], { encoding: 'ISO-8859-1' }));
        var fileURL =
          "data:text/csv;charset=utf-8,%EF%BB%BF" +
          encodeURIComponent(res.data);

        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        let fileName = res.headers.filename;
        if (!fileName) {
          fileName = "export.csv";
        }

        fileLink.setAttribute("download", fileName);

        document.body.appendChild(fileLink);
        fileLink.click();
      }
    },
    /**
     * Méthode appelé aprés la montage du composant
     */
    init() {
      this.findCategories();
      this.findProjets();
      this.findDevises();
      this.findSimpleAdherent();
      this.findModePaiement();
      this.findSaisieYears();
    },

    /**
     * Récupére la liste de toutes les catégories du serveur
     */
    findCategories() {
      ApiService.categories.findCategories().then((resp) => {
        this.categories = resp.data;
      });
    },
    /**
     * Récupére la liste de toutes les devises
     */
    findDevises() {
      ApiService.devises.findDevises().then((resp) => {
        this.devises = resp.data;
      });
    },
    /**
     * Récupére la liste de tous les projets du serveur
     */
    findProjets() {
      ApiService.projet.findProjets().then((resp) => {
        this.projets = resp.data;
      });
    },
    /**
     * Récupére la liste de tous les projets du serveur
     */
    findSimpleAdherent() {
      ApiService.adherents.findSimpleAdherents().then((resp) => {
        this.simpleAdherents = resp.data;
      });
    },
    /**
     * Récupére la liste de tous les mode de paiement du serveur
     */
    findModePaiement() {
      ApiService.modePaiement.findModePaiement().then((resp) => {
        this.modePaiements = resp.data;
      });
    },
    findSaisieYears() {
      ApiService.saisie.findYears().then((resp) => {
        this.years = resp.data;
      });
    },
    setAdherentId() {
      if (this.selectedAdherent && this.selectedAdherent.id) {
        this.search.adherentId = this.selectedAdherent.id;
      }
    },
  },
};
</script>
